<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				name="费用流程"
				label="费用流程"
				placeholder="选择费用流程"
				readonly
				@click="popup.process = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择费用流程' }]"
			/>
			<van-field
				v-model="type_text"
				name="费用类型"
				label="费用类型"
				placeholder="选择费用类型"
				readonly
				@click="popup.type = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择费用类型' }]"
			/>
			<van-field
				v-model="client_id_text"
				name="关联客户"
				label="关联客户"
				placeholder="选择关联客户"
				readonly
				@click="popup.select = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联客户' }]"
			/>
			<van-field
				v-model="form.je"
				name="费用金额"
				label="费用金额"
				placeholder="输入费用金额"
				type="number"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入费用金额' }]"
			/>
			<van-field
				v-model="form.occur_date"
				name="发生日期"
				label="发生日期"
				placeholder="选择发生日期"
				readonly
				@click="popup.calendar = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择发生日期' }]"
			/>
			<van-field
				v-model="form.cause"
				rows="3"
				autosize
				label="申请事由"
				type="textarea"
				placeholder="请输入申请事由"
				:rules="[{ required: true, trigger: 'onBlur', message: '请填写申请事由' }]"
			/>
			<van-field
				v-model="form.remark"
				rows="3"
				autosize
				label="备注"
				type="textarea"
				placeholder="请输入备注"
				:rules="[{ required: true, trigger: 'onBlur', message: '请填写备注' }]"
			/>
			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader
						v-model="uploader"
						:max-count="6"
						:after-read="onAfterRead"
						accept="all"
					/>
				</template>
			</van-field>
			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.type" position="bottom">
			<van-picker
				show-toolbar
				:columns="typeList"
				@cancel="picker.type = false"
				@confirm="confirmType"
			/>
		</van-popup>
		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="picker.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
		<van-calendar v-model="popup.calendar" @confirm="confirmCalendar" />
		<van-popup v-model="popup.select" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="clientList.list"
				@onload="onload"
				@check="check"
				:loading="clientList.loading"
				:finished="clientList.finished"
				value-key="client_name"
			></popup-select>
		</van-popup>
		<van-overlay :show="!signTime">
			<div class="wrapper">
				<van-loading size="24px">文件上传中,请稍后...</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
import popupselect from "@/components/select/index";
import { getNowFormatDate } from "@/utils/tool";
import { getList } from "@/api/review";
import { Toast } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { compressImage } from "@/utils/imageUtils"; 

export default {
	name: "cost",
	components: {
		"popup-select": popupselect
	},
	data() {
		return {
			uploader: [],
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			client_id_text: "",
			date: "",
			type_text: "",
			form: {
				type: "",
				client_id: "",
				occur_date: "",
				cost: "",
				cause: "",
				remark: ""
			},
			popup: {
				type: false,
				calendar: false,
				process: false,
				select: false
			},
			processList: [],
			typeList: [
				{ text: "差旅费报销", id: 9 },
				{ text: "差旅费预支", id: 0 },
				{ text: "办公费", id: 1 },
				{ text: "招待费", id: 2 },
				{ text: "市内交通费", id: 3 },
				{ text: "通讯费", id: 4 },
				{ text: "采购付款", id: 5 },
				{ text: "居间费", id: 7 },
				{ text: "劳务支出", id: 8 },
				{ text: "其他", id: 6 }
			],
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25
			},
			signTime: true
		};
	},
	mounted() {
		this.getLeaveList();
	},
	methods: {
		async onAfterRead(file) {
			//图片压缩
			if (file.file.type.startsWith('image/')) {
				const compressedFile = await compressImage(file.file);
				// 替换原始文件为压缩后的文件
				file.file = compressedFile;
				// console.log('File after compression:', file.file); // 添加调试信息
			} 
		},
		// onSubmit() {
		// 	this.$emit("sub", {
		// 		requestType: "process_apply",
		// 		process_id: this.process_id,
		// 		apply_data: JSON.stringify(this.form),
		// 		apply_rmb:  this.form.je
		// 	});
		// },
		onSubmit() {
			let that = this;
			let formData = new FormData();
			for (let i = 0; i < this.uploader.length; i++) {
				formData.append("file", this.uploader[i].file);
			}
			formData.append("process_id", this.process_id);
			formData.append("requestType", "process_apply");
			formData.append("apply_data",JSON.stringify(this.form));
			formData.append("apply_rmb", this.form.je);
			formData.append("token", getToken());

			const config = {
				timeout: 60 * 1000,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			this.signTime = false;

			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then((res) => {
					console.log(res);
					if (res.data.code === 200) {
						this.$route.params.listRefresh = true;
						this.$router.go(-1);
						Toast.fail("提交成功!");
					} else if (res.data.code === 300) {
						this.$router.push({
							path: "/login",
						});
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((err) => {
					console.log(err);
					that.signTime = true;
					let text = "当前网络环境差,请重新提交!";
					this.$toast.fail(text);
				});
		},
		confirmType(value) {
			this.type_text = value.text;
			this.form.type = value.id;
			this.popup.type = false;
		},
		confirmCalendar(value) {
			this.form.occur_date = getNowFormatDate(value);
			this.popup.calendar = false;
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		},
		getLeaveList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
			this.client_id_text = "";
			this.type_text = "";
		},
		check(value) {
			this.popup.select = false;
			this.client_id_text = value.client_name;
			this.form.client_id = value.client_id;
		},
		onload(search) {
			// 防止重复请求
			if (this.clientList.loading) {
				return;
			}
			// 设置加载状态
			this.clientList.loading = true;
			if (search != undefined) {
				this.clientList.page = 1;
			}
			getList({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(
							res.obj.rows
						);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return Toast.fail("数据异常");
				});
		}
	}
};
</script>